function OrganismePhotoLogin (props) {
  return (
    <div className='login-img-container'>
      <div className="login-img"/>
    </div>
  );
}

export default OrganismePhotoLogin;
